import LocalStore from '@/services/localStorage'
import useLogger from '@/composables/useLogger'
const logger = useLogger('appstore')

const ApplicationStore = {
  namespaced: true,
  state: {
    showFullPageView: false,
    showMiniNav: false,
    queryBuilderDedupeFlag: null,
    appNotification: {
      visible: false,
      showClose: false,
      message: '',
      type: 'error'
      // duration: 0
    },
    groups: {
      // NOTE: KEEP ADMIN GROUPS IN SYNC with backend COGNITO models/user.rb
      SUPER_ADMIN: 'superadmin',
      ACCOUNT_ADMIN: 'accountadmin'
    },
    dealerScopedView: true,
    currentDealer: {},
    localStorageFields: ['currentDealer', 'showMiniNav', 'queryBuilderDedupeFlag'] // add additional local storage fields here...
  },
  mutations: {
    // toggle from navigatable view to a full page view
    renderFullPageView: function (state) {
      if (!state.showFullPageView) {
        state.showFullPageView = true
      }
    },
    renderAppView: function (state) {
      if (state.showFullPageView) {
        state.showFullPageView = false
      }
    },
    resetNotification: function (state) {
      state.appNotification.visible = false
      state.appNotification.showClose = true
      state.appNotification.message = ''
      state.appNotification.type = 'error'
      // state.appNotification.duration = 0
    },
    setNotification: function (state, payload) {
      state.appNotification.showClose = payload.showClose
      state.appNotification.message = payload.message
      state.appNotification.type = payload.type
      state.appNotification.visible = true
      // state.appNotification.duration = 0
    },
    setDealerScopedView: (state, boolVal) => {
      state.dealerScopedView = boolVal
    },
    setCurrentDealer: (state, dealerObj) => {
      state.currentDealer = dealerObj
      LocalStore.setItem('currentDealer', dealerObj)
    },
    setShowMiniNav: (state, boolVal) => {
      state.showMiniNav = boolVal
      LocalStore.setItem('showMiniNav', boolVal)
    },
    setQueryBuilderDedupeFlag: (state, strVal) => {
      state.queryBuilderDedupeFlag = strVal
      LocalStore.setItem('queryBuilderDedupeFlag', strVal)
    }
  },
  actions: {
    showNotfication: function ({ commit }, payload) {
      commit('setNotification', payload)
      if (payload.duration && payload.duration > 0) {
        setTimeout(() => {
          commit('resetNotification')
        }, payload.duration)
      }
    },
    loadLocalAppSettings: function ({ state }) {
      state.localStorageFields.forEach(field => {
        try {
          state[field] = LocalStore.getItem(field)
          logger.trace('Loading Field', field, ' to ', state[field].name)
        } catch (error) {
          logger.trace('No current dealer in LocalStore')
        }
      })
    },
    saveLocalAppSettings: function ({ state }) {
      state.localStorageFields.forEach(field => {
        logger.trace('Setting Field', field, ' to ', state[field])
        LocalStore.setItem(field, state[field])
      })
    }
  },
  getters: {
    availableUserGroups: (state) => {
      return Object.values(state.groups)
    }
  }
}

export default ApplicationStore
